import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Identity from './identity';
export default (
  <Route path="identity">
    <IndexRoute component={props => <Identity {...props} />} />
  </Route>
);
